<mat-card class="do-it-card">
  <mat-card-header>
    <mat-card-title>{{ 'do-it.title' | translate }}</mat-card-title>
  </mat-card-header>
  <form [formGroup]="doItForm" (ngSubmit)="onSubmit()" style="margin: 20px 20px 0 20px;">
    <mat-card-content class="do-it-card-content">
      <div class="content-row-input">
        <span>{{ 'do-it.content' | translate }}</span>
      </div>
      <div class="content-row-input">
        <ul *ngIf="billingToDoList_Tonnage.length > 0">
          {{ 'label.billing-type-1'| translate }}
          <li *ngFor="let billingToDo of billingToDoList_Tonnage">{{ billingToDo.year }} - {{ ('label.month-' +
            billingToDo?.month) | translate}} | {{ billingToDo?.site?.name }}</li>
        </ul>

        <ul *ngIf="billingToDoList_Toll.length > 0">
          {{ 'label.billing-type-2'| translate }}
          <li *ngFor="let billingToDo of billingToDoList_Toll">{{ billingToDo.year }} - {{ ('label.month-' +
            billingToDo?.month) | translate}} | {{ billingToDo?.site?.name }}</li>
        </ul>

        <ul *ngIf="billingToDoList_Concession.length > 0">
          {{ 'label.billing-type-3'| translate }}
          <li *ngFor="let billingToDo of billingToDoList_Concession">{{ billingToDo.year }} - {{ ('label.quarter-' +
            billingToDo?.quarter) | translate}} | {{ billingToDo?.site?.name }}</li>
        </ul>
      </div>
      <div class="content-row-input">
        <span>{{ 'do-it.choice-date' | translate }}</span>
      </div>
      <mat-form-field class="content-row-input">
        <input matInput [matDatepicker]="date" formControlName="date" autocomplete="off" [min]="uiService.getMinDate()"
        [max]="uiService.getMaxDate()">
        <mat-datepicker-toggle matSuffix [for]="date"></mat-datepicker-toggle>
        <mat-datepicker #date [disabled]="doItForm.get('date')?.disabled"></mat-datepicker>
      </mat-form-field>
    </mat-card-content>
    <mat-card-actions class="do-it-card-action">
      <button mat-raised-button color="warn" type="button" (click)="onCancel()">
        <mat-icon>clear</mat-icon>{{ 'button.no' | translate }}
      </button>
      <button mat-raised-button color="primary" [disabled]="doItForm.invalid">
        <mat-icon>check</mat-icon>{{ 'button.yes' | translate }}
      </button>
    </mat-card-actions>
  </form>
</mat-card>